/* Q4 · carrito «como Stimulicat» (3/11): cajón lateral de la ficha de la cesta y página de carrito v2.
   El contenido lo pinta snippets/q4-cajon-contenido.liquid (sección q4-cajon); aquí solo se piden y se repintan.
   Regla: el comprador nunca se queda sin poder comprar. Si una petición falla, se sigue por el camino normal:
   el formulario de la ficha se envía a /cart/add (→ página de carrito), − + y la papelera van a /cart/change,
   «Aggiungi» se envía a /cart/add y el pago es un POST normal a /cart con name="checkout". */
(() => {
  'use strict';
  if (!window.fetch || !window.FormData || !window.URL) return;
  const raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const SEZ = 'q4-cajon';
  const cajon = document.querySelector('[data-q4cj-cajon]');
  const velo = document.querySelector('[data-q4cj-velo]');
  const dentro = cajon && cajon.querySelector('[data-q4cj-raiz]');
  const aceptaJson = { Accept: 'application/json' };
  let foco = null, temporizador = 0;

  // Sección que hay que repintar: la del contenido donde se ha pulsado (cajón = q4-cajon; página = su section.id).
  const seccionDe = (n) => { const c = n && n.closest('[data-q4cj-contenuto]'); return (c && c.getAttribute('data-q4cj-seccion')) || SEZ; };
  const enCajon = (n) => !!(cajon && n && cajon.contains(n));
  const contexto = (id) => (id === SEZ && dentro ? raiz : location.pathname + location.search);

  function pintar(id, html) {
    if (!html) return false;
    if (id === SEZ && dentro) { dentro.innerHTML = html; return true; }
    const vieja = document.getElementById('shopify-section-' + id);
    if (!vieja) return false;
    const t = document.createElement('div');
    t.innerHTML = html;
    const nueva = t.querySelector('.shopify-section') || t.firstElementChild;
    if (!nueva) return false;
    vieja.replaceWith(nueva);
    return true;
  }
  async function pedirSeccion(id) {
    const u = new URL(contexto(id), location.origin);
    u.searchParams.set('sections', id);
    const r = await fetch(u.toString(), { credentials: 'same-origin', headers: aceptaJson });
    if (!r.ok) throw new Error('sections ' + r.status);
    return (await r.json())[id];
  }
  // Usa el HTML que ya trae la respuesta del carrito («sections» en add.js/change.js); si no viene, lo pide aparte.
  async function repintar(id, datos) {
    let html = datos && datos.sections && datos.sections[id];
    if (!html) html = await pedirSeccion(id);
    if (!pintar(id, html)) throw new Error('repintar');
  }
  const ocupado = (si) => document.querySelectorAll('[data-q4cj-contenuto]').forEach((x) => x.classList.toggle('q4cj-occ', si));

  function abrir() {
    if (!cajon) return;
    clearTimeout(temporizador);
    if (cajon.hidden) foco = document.activeElement;
    velo.hidden = false; cajon.hidden = false;
    void cajon.offsetWidth;                                   // que la transición salga desde fuera de la pantalla
    velo.classList.add('on'); cajon.classList.add('on');
    cajon.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('q4cj-bloccato');
    const x = cajon.querySelector('[data-q4cj-chiudi]');
    setTimeout(() => { try { (x || cajon).focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function cerrar() {
    if (!cajon || cajon.hidden) return;
    velo.classList.remove('on'); cajon.classList.remove('on');
    cajon.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('q4cj-bloccato');
    temporizador = setTimeout(() => { velo.hidden = true; cajon.hidden = true; }, 320);
    if (foco && foco.focus) { try { foco.focus({ preventScroll: true }); } catch (e) {} }
  }
  async function enviarAlCarrito(form, id) {
    const fd = new FormData(form);
    fd.append('sections', id);
    fd.append('sections_url', contexto(id));
    const r = await fetch(raiz + 'cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
    if (!r.ok) throw new Error('cart/add ' + r.status);
    return r.json();
  }

  // 1. Ficha de la cesta: el botón de compra añade sin cambiar de página y abre el cajón.
  const ficha = cajon && document.getElementById('cs-form');
  if (ficha) {
    ficha.addEventListener('submit', async (ev) => {
      ev.preventDefault();
      const btn = ficha.querySelector('[type="submit"]');
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '.7'; }
      let datos;
      try { datos = await enviarAlCarrito(ficha, SEZ); }
      catch (e) { HTMLFormElement.prototype.submit.call(ficha); return; }   // sin añadir: el formulario normal
      finally { if (btn) { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; } }
      try { await repintar(SEZ, datos); abrir(); }
      catch (e) { location.href = raiz + 'cart'; }                           // ya está añadido: a la página de carrito
    });
  }

  // 2. Clics dentro del carrito (cajón o página): cerrar, flechas del carrusel, «Scegli la cesta», − + y papelera.
  document.addEventListener('click', async (ev) => {
    const t = ev.target.closest && ev.target.closest('[data-q4cj-chiudi],[data-q4cj-freccia],[data-q4cj-scegli],[data-q4cj-cambia]');
    if (!t) return;
    if (t.hasAttribute('data-q4cj-chiudi')) { ev.preventDefault(); cerrar(); return; }
    if (t.hasAttribute('data-q4cj-freccia')) {
      const p = t.closest('[data-q4cj-carosello]'); const pista = p && p.querySelector('[data-q4cj-pista]');
      if (!pista) return;
      const dir = Number(t.getAttribute('data-q4cj-freccia')), w = pista.clientWidth, max = pista.scrollWidth - w - 2;
      if (dir > 0 && pista.scrollLeft >= max) pista.scrollTo({ left: 0 });
      else if (dir < 0 && pista.scrollLeft <= 2) pista.scrollTo({ left: pista.scrollWidth });
      else pista.scrollBy({ left: dir * w });
      return;
    }
    if (t.hasAttribute('data-q4cj-scegli')) {
      // En la propia ficha de la cesta: se cierra el cajón y se baja al formulario en vez de recargar.
      if (enCajon(t) && ficha) { ev.preventDefault(); cerrar(); ficha.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }
    if (t.getAttribute('aria-disabled') === 'true') { ev.preventDefault(); return; }
    ev.preventDefault();
    const id = seccionDe(t);
    ocupado(true);
    try {
      const r = await fetch(raiz + 'cart/change.js', { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(t.getAttribute('data-linea')), quantity: Number(t.getAttribute('data-qta')),
          sections: [id], sections_url: contexto(id) }) });
      if (!r.ok) throw new Error('cart/change ' + r.status);
      await repintar(id, await r.json());
    } catch (e) { location.href = t.href; return; }
    finally { ocupado(false); }
  });

  // 3. «Aggiungi» de los complementos.
  document.addEventListener('submit', async (ev) => {
    const f = ev.target && ev.target.closest && ev.target.closest('form[data-q4cj-agg]');
    if (!f) return;
    ev.preventDefault();
    const id = seccionDe(f);
    ocupado(true);
    let datos;
    try { datos = await enviarAlCarrito(f, id); }
    catch (e) { ocupado(false); HTMLFormElement.prototype.submit.call(f); return; }
    try { await repintar(id, datos); }
    catch (e) { location.href = raiz + 'cart'; }
    finally { ocupado(false); }
  });

  // 4. Variante del complemento: el precio de la tarjeta sigue a la variante elegida.
  document.addEventListener('change', (ev) => {
    const s = ev.target;
    if (!s || !s.matches || !s.matches('select[data-q4cj-var]')) return;
    const o = s.options[s.selectedIndex], card = s.closest('.q4cj-up__card');
    if (!o || !card) return;
    const era = card.querySelector('[data-q4cj-era]'), con = card.querySelector('[data-q4cj-con]');
    if (era && o.dataset.era) era.textContent = o.dataset.era;
    if (con && o.dataset.con) con.textContent = o.dataset.con;
  });

  document.addEventListener('keydown', (ev) => { if (ev.key === 'Escape') cerrar(); });
})();
